import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const headerStyles = {
  divider: {
    margin: '0px 16px',
    width: '1px',
    height: '64px',
    background: 'rgba(255, 255, 255, 0.3)',
  },
  userName: { color: '#FFFFFF' },
  root: {
    color: '#FFFFFF',
    height: 64,
    boxShadow: 'none',
    position: 'static',
  },
  envMenu: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    width: '240px',
    height: '80px',
    // background: '#FFFFFF',
    borderRadius: '4px',
  },
  iconButton: {
    color: '#FFFFFF',
    width: '48px',
    height: '48px',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  },
  arrowIcon: {
    color: '#FFFFFF',
    width: '24px',
    height: '24px',
    '&:hover': {
      color: 'rgba(255, 255, 255, 0.8)',
    },
  },
  profileButton: {
    marginLeft: 0,
  },
  accountButton: {
    color: '#FFFFFF',
    marginRight: '16px',
    width: '48px',
    height: '48px',
    '&:hover': {
      color: 'rgba(255, 255, 255, 0.8)',
    },
  },
  envDivider: {
    width: '1px',
    height: '80px',
  },
  links: {
    marginLeft: 106,
    height: 63,
    paddingTop: 18,
  },
  link: {
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'uppercase',
    height: 16,
    letterSpacing: 1.25,
    color: 'rgb(0, 0, 0, 0.54)',
    marginRight: 36,
  },
  linkCurrent: {
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'uppercase',
    height: 16,
    letterSpacing: 1.25,
    marginRight: 36,
    color: 'rgb(0, 0, 0, 0.87)',
  },

  middleBreak: {
    flexGrow: 1,
  },
  helpButton: {
    minWidth: 36,
  },
  help: {
    color: '#000',
    opacity: 0.54,
  },
  envButton: {
    '&:hover': {
      background: 'none',
    },
  },
  iconColor: {
    color: '#FFFFFF',
    width: '40px',
    height: '40px',
  },
  textBox: {
    textTransform: 'initial',
    textAlign: 'start',
    ml: '4px',
    mr: '8px',
  },
  buttonLinkWrapper: {
    m: 1,
    backgroundColor: 'white',
    opacity: 0.7,
    '&:hover': {
      backgroundColor: 'lightgray',
    },
  },
  buttonLinkWrapperActive: {
    m: 1,
    backgroundColor: 'white',
    opacity: 1,
    '&:hover': {
      backgroundColor: 'white',
    },
  },
  linkInactive: {
    textDecoration: 'none',
    margin: '0 10px',
  },
  linkActive: {
    textDecoration: 'none',
    margin: '0 10px',
    color: 'black',
  },
};

export const useHeaderStyles = makeStyles<Theme>(theme => ({
  navigationLink: {
    height: '32px',

    '&.MuiButton-contained': {
      backgroundColor: theme.palette.grey.A100,
      color: 'black',
      // '&:hover': {
      //   backgroundColor: theme.palette.grey[700],
      // },
    },

    '&.MuiButton-outlined': {
      borderColor: theme.palette.grey[600],
      color: theme.palette.grey.A100,
      '&:hover': {
        backgroundColor: theme.palette.grey[700],
      },
    },
  },
}));
